import { loadStateFromStorage, saveStateToStorage } from 'helpers/localStorageHelper'

export const getAnonId = (): string => {
  const existingId = loadStateFromStorage('anon_id')
  if (existingId) return existingId

  const newId = Math.random().toString(36).substring(2, 12)
  saveStateToStorage('anon_id', newId)
  return newId
}
